import React, { useState } from "react";
import { Button } from "newui/components/Button";
import { InputWithLabel } from "newui/components/ui/InputWithLabel";

export interface TotpStartStepProps {
	error?: string;
	isSubmitting: boolean;
	onSubmit: (password: string) => void;
}

export const TotpStartStep = ({ error, isSubmitting, onSubmit }: TotpStartStepProps) => {
	const [password, setPassword] = useState("");

	const handleSubmit = (e: React.FormEvent) => {
		e.preventDefault();
		onSubmit(password);
	};

	return (
		<form onSubmit={handleSubmit} className="flex flex-col gap-4 !p-0">
			<p className="font-roboto text-sm text-gray-600">
				Confirm your password to generate a two-factor authentication QR code.
			</p>
			<InputWithLabel
				label="Password"
				type="password"
				icon
				value={password}
				onChange={(e) => setPassword(e.target.value)}
				errorText={error}
				testId="totp-setup-password-input"
				required
			/>
			<Button
				type="submit"
				btntype="primary"
				disabled={!password || isSubmitting}
				isLoading={isSubmitting}
				data-testid="enable-2fa-continue-btn"
			>
				Continue
			</Button>
		</form>
	);
};
